import { createSlice } from "@reduxjs/toolkit";

interface ModalState {
    outsideId: string,
    insideId: string,
    footerOutsideId: string,
    cartValue: number,
    cartValuePrice: number,
    totalPayableAmt: number,
    handlingAmt: number,
    convenienceAmt: number,
    status: boolean,
    ServiceName: string,
    discount: number,
    tipValue: number,
    oldValueOfCartItems: number,
    serviceId: number,
    priceRecordId: number,
    percentage: number,
    totalItems: number,
    globalError: boolean,
    loading: boolean,
    connection: any,
    extractDataFromService: any[],
    cartData: any[],
    CartItems: any,
    service: any[],
    cartValues: any[],
    viewOpenandClose: Array<{ cartId: string; isChecked: boolean }>,
    modelTitle: string
    fromDeleteService: boolean
    fromDeleteDoc: boolean
    serviceListData: any | null;
    clickedCartId: number
    isMobile: boolean,
    dedCategoryId: number,
    dedCategoryslug: string,
    dedGroupName: string | null,
    dedActivityCode: string,
}

const initialState: ModalState = {
    outsideId: "",
    insideId: "",
    footerOutsideId: "",
    cartValue: 0,
    cartValuePrice: 0,
    totalPayableAmt: 0,
    handlingAmt: 0,
    convenienceAmt: 0,
    status: false,
    ServiceName: "Summary",
    discount: 0,
    tipValue: 0,
    oldValueOfCartItems: 0,
    serviceId: 0,
    priceRecordId: 0,
    percentage: 100,
    totalItems: 0,
    globalError: false,
    loading: false,
    connection: null,
    extractDataFromService: [],
    cartData: [],
    CartItems: {},
    service: [],
    viewOpenandClose: [],
    cartValues: [],
    modelTitle: "",
    fromDeleteService: false,
    fromDeleteDoc: false,
    clickedCartId: 0,
    serviceListData: null,
    isMobile: false,
    dedCategoryId: 0,
    dedCategoryslug: "",
    dedGroupName: "",
    dedActivityCode: ""
}

const IdSlice = createSlice({
    name: "ID",
    initialState,
    reducers: {
        getID: (state, action) => {
            const { insideId, outsideId } = action.payload;
            state.outsideId = outsideId;
            state.insideId = insideId;
        },
        getInsideID: (state, action) => {
            const { insideId } = action.payload;
            state.insideId = insideId;
        },
        getOutsideID: (state, action) => {
            const { footerOutsideId } = action.payload;
            state.footerOutsideId = footerOutsideId;
        },
        setTrue: (state) => {
            state.status = true;
        },
        setFalse: (state) => {
            state.status = false;
        },
        setCartValue: (state, action) => {
            const { ItemInCart } = action.payload;
            state.cartValue = ItemInCart;
        },
        setcartValuePrice: (state, action) => {
            const { totalAmountOfCartItem } = action.payload;
            state.cartValuePrice = totalAmountOfCartItem;
        },
        setPayableAmount: (state, action) => {
            state.totalPayableAmt = parseFloat(action.payload);
        },
        setHandlingAmount: (state, action) => {
            state.handlingAmt = parseFloat(action.payload);
        },
        setConvenienceAmount: (state, action) => {
            state.convenienceAmt = parseFloat(action.payload);
        },
        setServiceNames: (state, action) => {
            const { ServiceNames } = action.payload;
            state.ServiceName = ServiceNames;
        },
        setDiscount: (state, action) => {
            const { discount } = action.payload;
            state.discount = discount;
        },
        setTipValue: (state, action) => {
            state.tipValue = action.payload;
        },
        setOldValueOfCartItems: (state, action) => {
            const { oldTotalAmount } = action.payload;
            state.oldValueOfCartItems = oldTotalAmount;
        },
        setServiceId: (state, action) => {
            state.serviceId = action.payload
        },
        setGlobalError: (state, action) => {
            state.globalError = action.payload
        },
        setGlobalLoading: (state, action) => {
            state.loading = action.payload
        },
        setConnection: (state, action) => {
            state.connection = action.payload
        },
        setExtractData: (state, action) => {
            state.extractDataFromService = action.payload;
        },
        setExtractDataFromServiceEmpty: (state) => {
            state.extractDataFromService = [];
        },
        setCartData: (state, action) => {
            state.cartData = action.payload;
        },
        setCartItems: (state, action) => {
            state.CartItems = action.payload;
        },
        setPercentage: (state, action) => {
            state.percentage = action.payload;
        },
        setTotalItems: (state, action) => {
            state.totalItems = action.payload;
        },
        setService: (state, action) => {
            state.service = action.payload;
        },
        setCartValues: (state, action) => {
            state.cartValues = action.payload;
        },
        setViewOpenandClose: (state, action) => {
            state.viewOpenandClose = action.payload;
        },
        changeViewOpenandClose: (state, action) => {
            const { clickedCartId } = action.payload;
            state.viewOpenandClose = state.viewOpenandClose?.map((item) => {
                if (item.cartId === clickedCartId) {
                    return { ...item, isChecked: !item.isChecked };
                } else {
                    return { ...item, isChecked: false };
                }
            });
        },
        setModelTitle: (state, action) => {
            state.modelTitle = action.payload;
        },
        setFromDeleteService: (state, action) => {
            state.fromDeleteService = action.payload;
        },
        setFromDeleteDoc: (state, action) => {
            state.fromDeleteDoc = action.payload;
        },
        setServiceListData: (state, action) => {
            state.serviceListData = action.payload;
        },
        setClickedCartId: (state, action) => {
            state.clickedCartId = action.payload;
        },
        toggleIsMobile: (state, action) => {
            state.isMobile = action.payload;
        },
        setActivityCategory: (state, action) => {
            state.dedCategoryId = action.payload.catId;
            state.dedCategoryslug = action.payload.slug;
        },
        setActivityGroup: (state, action) => {
            state.dedGroupName = action.payload
        },
        setActivityCode: (state, action) => {
            state.dedActivityCode = action.payload
        },
        getActivityCategory: (state, action) => {
            state.dedCategoryId = action.payload.catId;
            state.dedCategoryslug = action.payload.slug;
        },
        getActivityGroup: (state, action) => {
            state.dedGroupName = action.payload
        },
        getActivityCode: (state, action) => {
            state.dedActivityCode = action.payload
        },
    }

})

export const {
    getID, getInsideID, getOutsideID, setTrue, setFalse, setCartValue, setcartValuePrice, setPayableAmount, setHandlingAmount, setConvenienceAmount, setServiceNames, setTipValue, setDiscount,
    setOldValueOfCartItems, setServiceId, setGlobalError, setGlobalLoading, setExtractData, setExtractDataFromServiceEmpty, setCartData,
    setCartItems, setPercentage, setTotalItems, setService, setViewOpenandClose, changeViewOpenandClose, setCartValues, setModelTitle, setFromDeleteService, setFromDeleteDoc, setClickedCartId, setServiceListData,
    toggleIsMobile, setActivityCategory, setActivityGroup, setActivityCode, getActivityCategory, getActivityCode, getActivityGroup
 } = IdSlice.actions

export default IdSlice.reducer
